import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { SYSTEM_ALLOWED_DATA_SOURCES } from './dataSourcePolicy.js';
import { PRINTER } from '../types/printer.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
export const printerDescriptor = {
    name: PRINTER,
    label: 'Impressora',
    domain: 'system',
    collectionPath: 'org/{orgId}/printers',
    pathPatternKeys: {
        orgId: 'string',
    },
    version: 1,
    description: 'Impressoras remotas registradas no SysColect (subset exposto pelo VectorHub). System/Firestore-only — not a business catalog.',
    repositoryConfig: {
        dataSource: DataSourceStrategy.Firestore,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: SYSTEM_ALLOWED_DATA_SOURCES,
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Deterministic id: agentId__printerName',
        },
        {
            name: 'agentId',
            label: 'Agente',
            type: 'string',
            required: true,
            description: 'VectorHub agent id',
        },
        {
            name: 'agentName',
            label: 'Nome do agente',
            type: 'string',
            required: false,
            maxLength: FIELD_LIMITS.NAME,
            description: 'Agent display name snapshot',
        },
        {
            name: 'printerName',
            label: 'Impressora (SO)',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.PRINTER_OS_NAME,
            description: 'OS printer name on the agent host',
        },
        {
            name: 'label',
            label: 'Nome amigável',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.PRINTER_LABEL,
            description: 'Label shown in print combos',
        },
        {
            name: 'description',
            label: 'Descrição',
            type: 'string',
            required: false,
            maxLength: FIELD_LIMITS.PRINTER_DESCRIPTION,
            description: 'Optional disambiguation text',
        },
    ],
};
//# sourceMappingURL=printer.descriptor.js.map